export default __webpack_public_path__ + "static/media/26.0aa422d7.jpg";